export const CATALOGS = [
  {
    id: 'complete',
    route: '/catalogs/complete',
    title: 'Complete Product Catalog',
    category: 'All Products',
    description: 'Full H.A Surgical range — 1,300+ products across all specialties.',
    file: '/catalogs/complete/ha-surgical-catalog.pdf',
    pages: 1324,
    size: '59 MB',
    featured: true,
  },
  {
    id: 'general-surgery',
    route: '/catalogs/general-surgery',
    title: 'General Surgery Catalog',
    category: 'General Surgery',
    description: 'Scissors, forceps, retractors, clamps, and general surgical instruments.',
    file: '/catalogs/general-surgery/general-surgery-catalog.pdf',
    pages: 382,
    size: '87 MB',
    productCategories: ['General Surgery'],
  },
  {
    id: 'dental',
    route: '/catalogs/dental',
    title: 'Dental Instruments Catalog',
    category: 'Dental',
    description: 'Scalers, explorers, extraction forceps, mirrors, and complete dental sets.',
    file: '/catalogs/dental/dental-catalog.pdf',
    pages: 234,
    size: '45 MB',
    productCategories: ['Dental'],
  },
  {
    id: 'orthopedic-hand',
    route: '/catalogs/orthopedic/hand',
    title: 'Orthopedic Hand Instruments',
    category: 'Orthopedic',
    description: 'Bone chisels, mallets, rasps, retractors, and hand surgery instruments.',
    file: '/catalogs/orthopedic/hand/orthopedic-hand-catalog.pdf',
    pages: 79,
    size: '73 MB',
    productCategories: ['Orthopedic'],
  },
  {
    id: 'locking-plates',
    route: '/catalogs/orthopedic/locking-plates',
    title: 'Locking Plates System',
    category: 'Orthopedic',
    description: 'Locking plate systems for fracture fixation and orthopedic trauma surgery.',
    file: '/catalogs/orthopedic/locking-plates/locking-plates-catalog.pdf',
    pages: 22,
    size: '4.3 MB',
    productCategories: ['Orthopedic'],
  },
  {
    id: 'non-locking-plates',
    route: '/catalogs/orthopedic/non-locking-plates',
    title: 'Non-Locking Plates',
    category: 'Orthopedic',
    description: 'Standard non-locking plate systems for orthopedic fixation procedures.',
    file: '/catalogs/orthopedic/non-locking-plates/non-locking-plates-catalog.pdf',
    pages: 29,
    size: '2.4 MB',
    productCategories: ['Orthopedic'],
  },
];

export function getCatalogByRoute(pathname) {
  return CATALOGS.find(c => c.route === pathname);
}

export function getCatalogsForCategory(category) {
  return CATALOGS.filter(c => c.productCategories?.includes(category));
}
